<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}
                </router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="status != 'DRAFT'"
                >
                  <v-text-field
                    slot="activator"
                    label="Issue Date"
                    type="text"
                    prepend-icon="event"
                    v-model="issueDate"
                    :rules="rules.required('Issue date')"
                  ></v-text-field>
                  <v-date-picker v-model="issueDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="productionOrder.id">
                <v-text-field
                  name="Issue No"
                  label="Issue No"
                  v-model="productionOrder.issueNo"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex :class="productionOrder.id ? 'sm6' : 'sm12'">
                <v-text-field
                  name="Po No"
                  label="Po No"
                  v-model="productionOrder.poNo"
                  type="text"
                  :rules="rules.required('Po No')"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="productionOrder.shopId"
                  :items="shopList"
                  color="blue-grey lighten-2"
                  label="Select Shop..."
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  :hide-no-data="true"
                  :rules="rules.required('Shop')"
                  :readonly="
                    status != 'DRAFT' || checkShopUser() ? true : false
                  "
                  @change="productionOrder.productionPlanNo = ''"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="productionOrder.warehouseId"
                  :items="warehouseList"
                  color="blue-grey lighten-2"
                  label="Select Warehouse..."
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  :hide-no-data="true"
                  :rules="rules.required('Warehouse')"
                  :readonly="
                    status != 'DRAFT' || checkWarehouseUser() ? true : false
                  "
                  @change="
                    changeWarehouse(), (productionOrder.productionPlanNo = '')
                  "
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="productionOrder.fromDepartmentId"
                  :items="departmentList"
                  color="blue-grey lighten-2"
                  label="Choose From Department..."
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  :hide-no-data="true"
                  :rules="rules.required('From Department')"
                  :readonly="status != 'DRAFT'"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="productionOrder.toDepartmentId"
                  :items="departmentList"
                  color="blue-grey lighten-2"
                  label="Choose To Department..."
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  :hide-no-data="true"
                  :rules="rules.required('To Department')"
                  :readonly="status != 'DRAFT'"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-layout>
                  <v-flex sm10>
                    <v-text-field
                      name="productionPlanNo"
                      label="Production Plan No"
                      v-model="productionOrder.productionPlanNo"
                      type="text"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm1 v-if="productionOrder.productionPlanNo">
                    <v-btn
                      color="red"
                      outline
                      icon
                      @click="productionOrder.productionPlanNo = ''"
                      :disabled="status != 'DRAFT'"
                    >
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex sm1>
                    <v-btn
                      outline
                      color="primary"
                      icon
                      :disabled="
                        productionOrder.productionPlanNo || status != 'DRAFT'
                          ? true
                          : false
                      "
                      @click="showProductionPlan"
                    >
                      <v-icon dark>search</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="productName"
                  label="Product"
                  v-model="productionOrder.productName"
                  type="text"
                  @click="showProductDialog()"
                  :rules="rules.required('Product')"
                  readonly
                  :disabled="status != 'DRAFT'"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="productionOrder.factorUnitName"
                  :hide-no-data="true"
                  :items="productionOrder.productUnits"
                  label="Unit"
                  item-value="factorUnitName"
                  item-text="factorUnitName"
                  menu-props="auto"
                  :readonly="!productionOrder.productId || status != 'DRAFT'"
                  :rules="rules.required('Unit')"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="qty"
                  label="Qty"
                  v-model="productionOrder.qty"
                  type="number"
                  :rules="rules.geraterThanZeroQtyRules('Qty')"
                  :readonly="status != 'DRAFT'"
                ></v-text-field>
              </v-flex>
              <v-flex
                :class="status == 'CONFIRM' ? 'sm6' : 'sm12'"
                v-if="productionOrder.id"
              >
                <v-select
                  :items="statusList"
                  label="Status"
                  v-model="productionOrder.status"
                  item-text="label"
                  item-value="value"
                  :readonly="status != 'DRAFT'"
                  :rules="rules.required('Status')"
                ></v-select>
              </v-flex>
              <v-flex sm6 v-if="status == 'CONFIRM'">
                <v-text-field
                  name="batchNo"
                  v-model="productionOrder.batchNo"
                  label="Batch No"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="status == 'CONFIRM'">
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  disabled
                >
                  <v-text-field
                    slot="activator"
                    label="mfg Date"
                    type="text"
                    prepend-icon="event"
                    v-model="mfgDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="mfgDate" disabled></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="status == 'CONFIRM'">
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  disabled
                >
                  <v-text-field
                    slot="activator"
                    label="exp Date"
                    type="text"
                    prepend-icon="event"
                    v-model="expDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="expDate" disabled></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="status == 'CONFIRM'">
                <v-text-field
                  name="productionQty"
                  v-model="productionOrder.productionQty"
                  label="Production Qty"
                  type="number"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="status == 'CONFIRM'">
                <v-text-field
                  name="productionFactorUnitName"
                  v-model="productionOrder.productionFactorUnitName"
                  label="Production Unit"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="Remark"
                  label="Remark"
                  v-model="productionOrder.remark"
                  type="text"
                  :readonly="status != 'DRAFT'"
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="productionOrder.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="productionOrder.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="productionOrder.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="productionOrder.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="productionOrder.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="productionOrder.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 class="mt-1">
                <v-layout row wrap>
                  <v-btn color="success" @click="showMultiProductListDialog()">
                    ADD PRODUCT
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>
                <v-card>
                  <v-data-table
                    :headers="detailHeaders"
                    :items="productionOrder.productionOrderDetailList"
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td>{{ props.item.itemProductCode }}</td>
                      <td>{{ props.item.itemProductName }}</td>
                      <td>
                        <v-autocomplete
                          v-model="props.item.binId"
                          :hide-no-data="true"
                          :items="binList"
                          label="Bin"
                          item-value="id"
                          item-text="name"
                          menu-props="auto"
                          :rules="rules.required('Bin')"
                          style="width: 225px"
                          :readonly="status != 'DRAFT'"
                          @change="getProductQcBatchDateList(props.item)"
                        ></v-autocomplete>
                      </td>
                      <td>
                        <v-autocomplete
                          v-model="props.item.factorUnitName"
                          :hide-no-data="true"
                          :items="props.item.productUnits"
                          color="blue-grey lighten-2"
                          item-value="factorUnitName"
                          item-text="factorUnitName"
                          menu-props="auto"
                          :rules="rules.unitRules"
                          style="width: 150px"
                        ></v-autocomplete>
                      </td>
                      <td>
                        <v-autocomplete
                          v-model="props.item.qcNo"
                          :hide-no-data="true"
                          :items="props.item.stockQcNoDTOList"
                          item-text="qcNo"
                          item-value="qcNo"
                          color="blue-grey lighten-2"
                          menu-props="auto"
                          style="width: 225px"
                          :disabled="
                            status != 'DRAFT' || props.item.binId ? false : true
                          "
                          @change="changeQcNo(props.item)"
                        ></v-autocomplete>
                        <span style="color: red" v-if="!props.item.binId"
                          >Please select bin first.</span
                        >
                      </td>
                      <td>{{ props.item.stockBalanceQty | decFormat(6) }}</td>
                      <td>
                        <v-text-field
                          name="itemQty"
                          type="number"
                          v-model="props.item.itemQty"
                          :rules="rules.zeroQtyRules('Qty')"
                          style="width: 200px"
                          :readonly="status != 'DRAFT'"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          name="issueQty"
                          type="number"
                          v-model="props.item.issueQty"
                          style="width: 200px"
                          readonly
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          name="usageQty"
                          type="number"
                          v-model="props.item.usageQty"
                          style="width: 200px"
                          readonly
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          name="specialInstruction"
                          placeholder="Special Instruction"
                          v-model="props.item.specialInstruction"
                          style="width: 225px"
                          :readonly="status != 'DRAFT'"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-btn
                          icon
                          @click="remove(props.item.id)"
                          :disabled="status != 'DRAFT'"
                        >
                          <v-icon>cancel</v-icon>
                        </v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn
                    color="error"
                    @click="clear"
                    :disabled="
                      status != 'DRAFT' ||
                      user.role.roleName == 'WAREHOUSE_MANAGER' ||
                      user.role.roleName == 'WAREHOUSE_STAFF'
                    "
                  >
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="
                      !valid ||
                      saveLoading ||
                      status != 'DRAFT' ||
                      user.role.roleName == 'WAREHOUSE_MANAGER' ||
                      user.role.roleName == 'WAREHOUSE_STAFF'
                    "
                    type="submit"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!--single select product list dialog-->
    <ProductListDialog
      :showDialog="showProductListDialog"
      :params="{ status: 'ACTIVE', productType: 'PRODUCTION' }"
      @close="closeProductListDialog"
    ></ProductListDialog>

    <!--multi select product list dialog-->
    <multi-select-product-list-dialog
      :showDialog="showMultiProductDialog"
      :params="{
        status: 'ACTIVE',
        productType: 'STANDARD',
      }"
      @close="closeProductDialog"
    ></multi-select-product-list-dialog>

    <!--single select production plan list dialog-->
    <production-plan-dialog
      :showDialog="showProductionPlanListDialog"
      :params="{
        fromDate: currentDate,
        toDate: currentDate,
        status: 'PENDING',
        warehouseId: productionOrder.warehouseId,
        shopId: productionOrder.shopId,
      }"
      @close="closeProductionPlanListDialog"
    ></production-plan-dialog>

    <!-- error message dialog -->
    <v-dialog
      v-model="messageDialogBox"
      max-width="500px"
      @keydown.enter="messageDialogBox = false"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { productionOrderService } from "../../services/production-order-service";
import { ProductionOrder, ProductionOrderDetail } from "../../models/model";
import { ProductionOrderFormRules } from "../../helpers/validation-rules";
import { commonService } from "../../services/common-service";
import { departmentService } from "../../services/department-service";
import { shopService } from "../../services/shop-service";
import { warehouseService } from "../../services/warehouse-service";
import { stockService } from "../../services/stock-service";
import ProductListDialog from "../dialogs/ProductListDialog";
import ProductionPlanDialog from "../dialogs/ProductionPlanDialog";
import MultiSelectProductListDialog from "../dialogs/MultiSelectProductListDialog";

export default {
  name: "ProductionOrderDetail",
  components: {
    ProductListDialog,
    ProductionPlanDialog,
    MultiSelectProductListDialog,
  },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    showProductListDialog: false,
    showProductionPlanListDialog: false,
    saveLoading: false,
    messageDialogBox: false,
    breadcrumbs: [
      {
        text: "Production Order",
        disabled: false,
        to: "production-orders",
      },
      {
        text: "Production Order Detail",
        disabled: true,
      },
    ],
    detailHeaders: [
      { text: "Code", sortable: false },
      { text: "Name", sortable: false },
      { text: "Bin", sortable: false },
      { text: "Unit", sortable: false },
      { text: "QC No", sortable: false },
      { text: "Stock Balance", sortable: false },
      { text: "Qty", sortable: false },
      { text: "Issue Qty", sortable: false },
      { text: "Usage Qty", sortable: false },
      { text: "Special Instruction", sortable: false },
      { text: "Action", sortable: false },
    ],
    statusList: [
      { label: "DRAFT", value: "DRAFT" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    productionOrder: new ProductionOrder(),
    oldProductionOrder: new ProductionOrder(),
    productionOrderDetail: new ProductionOrderDetail(),
    rules: new ProductionOrderFormRules(),
    updatedDate: "",
    createdDate: "",
    currentDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
    issueDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
    mfgDate: "",
    expDate: "",
    status: "DRAFT",
    responseError: "",
    showMultiProductDialog: false,
    shopList: [],
    warehouseList: [],
    departmentList: [],
    binList: [],
  }),
  productionPlanPagination: {
    handler() {
      this.getProductionPlanList();
    },
    deep: true,
  },
  created() {
    this.productionOrder.shopId = this.checkShopUser();
    this.productionOrder.warehouseId = this.checkWarehouseUser();
    this.getDepartmentList();
    this.getShopList();
    this.getWarehouseList();
    const id = this.$route.params.id;
    if (id != "new") {
      this.getProductionItemDetail(id);
    }
  },
  methods: {
    checkWarehouseUser() {
      if (this.user.role.roleName == "BRANCH_ADMIN") {
        return this.user.warehouseId;
      } else if (this.user.roleName == "PRODUCTION_MANAGER") {
        return this.user.shop.warehouseId;
      } else {
        return "";
      }
    },
    checkShopUser() {
      if (
        this.user.role.roleName == "BRANCH_ADMIN" ||
        this.user.role.roleName == "PRODUCTION_MANAGER"
      ) {
        return this.user.shopId;
      } else {
        return "";
      }
    },
    getDepartmentList() {
      departmentService
        .getDepartmentsByStatus("ACTIVE")
        .then((res) => {
          this.departmentList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getWarehouseList() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
          this.getWarehouseBinList();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    changeWarehouse() {
      this.productionOrder.productionOrderDetailList.forEach((detail) => {
        detail.binId = "";
        detail.qcNo = "";
        detail.stockBalanceQty = 0;
      });
      this.getWarehouseBinList();
    },
    getWarehouseBinList() {
      let warehouse = commonService.search(
        "id",
        this.productionOrder.warehouseId,
        this.warehouseList
      );
      if (warehouse) {
        this.binList = warehouse.binList.filter((v) => v.status == "ACTIVE");
      }
    },
    showProductionPlan() {
      if (this.productionOrder.warehouseId && this.productionOrder.shopId) {
        this.showProductionPlanListDialog = !this.showProductionPlanListDialog;
      } else {
        this.messageDialogBox = true;
        if (!this.productionOrder.shopId) {
          this.responseError = "Please select shop first.";
        } else if (!this.productionOrder.warehouseId) {
          this.responseError = "Please select warehouse first.";
        }
      }
    },
    closeProductionPlanListDialog(productionPlan) {
      this.showProductionPlanListDialog = false;
      if (!(JSON.stringify(productionPlan) === "{}")) {
        this.productionOrder.productionPlanNo = productionPlan.issueNo;
      }
    },
    showProductDialog() {
      if (this.productionOrder.warehouseId) {
        this.showProductListDialog = !this.showProductListDialog;
      } else {
        this.messageDialogBox = true;
        this.responseError = "Please select warehouse first.";
      }
    },
    showMultiProductListDialog() {
      if (!this.productionOrder.warehouseId) {
        this.messageDialogBox = true;
        this.responseError = "Please select warehouse first.";
      } else {
        if (!this.productionOrder.productId) {
          this.messageDialogBox = true;
          this.responseError = "Please select product first.";
        } else {
          this.showMultiProductDialog = !this.showMultiProductDialog;
        }
      }
    },
    generateId() {
      let duplicateFlag = true;
      let id;

      // generate random id until it's unique
      while (duplicateFlag) {
        id = Math.floor(Math.random() * 9999 + 1);

        // find if id is duplicated
        let duplicateDetail =
          this.productionOrder.productionOrderDetailList.find(
            (d) => d.id == id
          );
        if (!duplicateDetail) duplicateFlag = false;
      }
      return id;
    },
    addProductionOrderDetail() {
      let productionOrderDetail = JSON.parse(
        JSON.stringify(this.productionOrderDetail)
      );

      // if no id, add temporary id for key
      if (!productionOrderDetail.id) {
        productionOrderDetail.isNew = true;
        productionOrderDetail.id = this.generateId();
      }
      return productionOrderDetail;
    },
    closeProductListDialog(product) {
      this.showProductListDialog = !this.showProductListDialog;
      if (!(JSON.stringify(product) === "{}")) {
        this.productionOrder.batchNo = "";
        this.productionOrder.productId = product.id;
        this.productionOrder.productName = product.name;
        this.productionOrder.productUnits = product.productUnits;
        let basicPu = product.productUnits.find((v) => v.isBasicUnit == true);
        if (basicPu) {
          this.productionOrder.productUnitId = basicPu.id;
          this.productionOrder.factorUnitName = basicPu.factorUnitName;
        }
        if (this.productionOrder.id) {
          //delete all old product's items first
          this.productionOrder.productionOrderDetailList.forEach((detail) => {
            if (!detail.isNew) {
              // add delete production order detail id
              if (!this.productionOrder.deleteProductionOrderDetailIds) {
                this.productionOrder.deleteProductionOrderDetailIds = [];
              }
              this.productionOrder.deleteProductionOrderDetailIds.push(
                detail.id
              );
            }
          });
        }
        this.productionOrder.productionOrderDetailList = [];
        product.productItems.forEach((productItem) => {
          let productionOrderDetail = this.addProductionOrderDetail();
          productionOrderDetail.itemProductId = productItem.itemProductId;
          productionOrderDetail.itemProductCode = productItem.itemProductCode;
          productionOrderDetail.itemProductName = productItem.itemProductName;
          productionOrderDetail.productUnitId = productItem.itemProductUnitId;
          productionOrderDetail.factorUnitName = productItem.factorUnitName;
          productionOrderDetail.productUnits = productItem.productUnits;
          productionOrderDetail.binId = "";
          productionOrderDetail.qcNo = "";
          productionOrderDetail.itemQty = productItem.itemProductQty;
          productionOrderDetail.issueQty = 0;
          productionOrderDetail.usageQty = 0;
          productionOrderDetail.specialInstruction = "";
          this.productionOrder.productionOrderDetailList.push(
            productionOrderDetail
          );
        });
      }
    },
    getProductQcBatchDateList(productionOrderDetail) {
      productionOrderDetail.qcNo = "";
      let params = {
        warehouseId: this.productionOrder.warehouseId,
        binId: productionOrderDetail.binId,
        productId: productionOrderDetail.itemProductId,
        balanceType: "WITH_BALANCE",
      };
      return stockService
        .getStockQcBatchDateList(params)
        .then((res) => {
          productionOrderDetail.stockQcNoDTOList = res.data;
          let qc = productionOrderDetail.stockQcNoDTOList.find(
            (v) => v.qcNo == productionOrderDetail.qcNo
          );
          if (qc) {
            productionOrderDetail.stockBalanceQty = qc.qcStockQty;
          } else {
            productionOrderDetail.stockBalanceQty = 0;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeQcNo(productionOrderDetail) {
      let qc = productionOrderDetail.stockQcNoDTOList.find(
        (v) => v.qcNo == productionOrderDetail.qcNo
      );
      if (qc) {
        productionOrderDetail.stockBalanceQty = qc.qcStockQty;
      } else {
        productionOrderDetail.stockBalanceQty = 0;
      }
    },
    closeProductDialog(selectedList) {
      selectedList.forEach((productItem) => {
        let productionOrderDetail = this.addProductionOrderDetail();
        productionOrderDetail.itemProductId = productItem.id;
        productionOrderDetail.itemProductCode = productItem.code;
        productionOrderDetail.itemProductName = productItem.name;
        productionOrderDetail.productUnits = productItem.productUnits;
        let basicPu = productItem.productUnits.find((v) => v.basicUnit == true);
        console.log("aa=", basicPu);
        if (basicPu) {
          productionOrderDetail.productUnitId = basicPu.id;
          productionOrderDetail.factorUnitName = basicPu.factorUnitName;
        }
        productionOrderDetail.binId = "";
        productionOrderDetail.qcNo = "";
        productionOrderDetail.itemQty = 0;
        productionOrderDetail.issueQty = 0;
        productionOrderDetail.usageQty = 0;
        productionOrderDetail.specialInstruction = "";
        this.productionOrder.productionOrderDetailList.unshift(
          productionOrderDetail
        );
      });
      this.showMultiProductDialog = !this.showMultiProductDialog;
    },
    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.saveLoading) {
          this.saveLoading = true;
          this.productionOrder.issueDateInMilliSeconds =
            commonService.convertToMilliseconds(this.issueDate);
          this.productionOrder.productionOrderDetailList.forEach((item) => {
            if (item.isNew) item.id = null;
          });
          productionOrderService
            .saveProductionOrder(this.productionOrder)
            .then((res) => {
              console.log(res);
              this.goBack();
            })
            .catch((err) => {
              console.log(err);
              if (err.response.data) {
                this.responseError = err.response.data.message;
                this.messageDialogBox = true;
              }
              this.saveLoading = false;
            });
        }
      }
    },
    getProductionItemDetail(id) {
      productionOrderService
        .getProductionOrderDetail(id)
        .then((res) => {
          this.productionOrder = res.data;
          this.status = this.productionOrder.status;
          this.issueDate = commonService.millisecondToDate(
            this.productionOrder.issueDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          if (this.productionOrder.mfgDateInMilliSeconds) {
            this.mfgDate = commonService.millisecondToDate(
              this.productionOrder.mfgDateInMilliSeconds,
              "YYYY-MM-DD"
            );
          }
          if (this.productionOrder.expDateInMilliSeconds) {
            this.expDate = commonService.millisecondToDate(
              this.productionOrder.expDateInMilliSeconds,
              "YYYY-MM-DD"
            );
          }
          this.createdDate = commonService.millisecondToDate(
            this.productionOrder.createdInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.millisecondToDate(
            this.productionOrder.updatedInMilliSeconds,
            "YYYY-MM-DD"
          );
          //if warehouse is inactive, add inactive warehouse to show in UI
          if (this.productionOrder.warehouse) {
            this.warehouseList.push(this.productionOrder.warehouse);
          }
          //if from department is inactive, add inactive department to show in UI
          if (this.productionOrder.fromDepartment) {
            this.departmentList.push(this.productionOrder.fromDepartment);
          }
          //if to warehouse is inactive, add inactive department to show in UI
          if (this.productionOrder.toDepartment) {
            this.departmentList.push(this.productionOrder.toDepartment);
          }
          this.getWarehouseBinList();
          this.oldProductionOrder = Object.assign({}, res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    remove(id) {
      const index = this.productionOrder.productionOrderDetailList
        .map((d) => d.id)
        .indexOf(id);
      if (!this.productionOrder.productionOrderDetailList[index].new) {
        if (!this.productionOrder.deleteProductionOrderDetailIds) {
          this.productionOrder.deleteProductionOrderDetailIds = [];
        }
        this.productionOrder.deleteProductionOrderDetailIds.push(id);
      }
      this.$delete(this.productionOrder.productionOrderDetailList, index);
    },
    clear() {
      this.$refs.form.resetValidation();
      this.responseError = "";
      if (!this.productionOrder.id) {
        this.productionOrder = new ProductionOrder();
      } else {
        this.productionOrder = Object.assign({}, this.oldProductionOrder);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
